import createAxios from 'config/axios'

const getPendency = () => createAxios.get('spc/v1/customers/pendencies/actions')

export default getPendency
